import React, { useEffect, useState } from 'react';
import { Plus, X } from 'lucide-react';
import { albiAPI } from '../../services/api';

/**
 * IscrizioniAlbo — le iscrizioni all'albo di un professionista, dentro
 * la scheda del medico.
 *
 * DUE TENDINE, NON DUE CAMPI DI TESTO. L'albo si sceglie da una lista
 * chiusa e la sede dalla lista delle sedi DI QUELL'ALBO: per l'Ordine
 * dei Medici le province, per gli Psicologi le regioni, per TSRM e
 * Fisioterapisti le sedi territoriali. E' cosi' che non nascono «RN»,
 * «Rimini», «RN/FC» e «rimini» - e il vincolo vero sta nel database,
 * che rifiuta una sede che non e' dell'albo.
 *
 * PIU' RIGHE: una fisioterapista che e' anche osteopata ha due titoli e
 * due iscrizioni. Una e' «principale» ed e' quella che si stampa per
 * difetto sui referti.
 *
 * Non salva da se': tiene l'elenco e lo consegna al modulo del medico,
 * che lo manda col resto.
 */
const VUOTA = { albo_codice: '', sede_id: '', numero: '', sezione: '', data_iscrizione: '', principale: false };

const IscrizioniAlbo = ({ valore = [], onChange, disabilitato = false }) => {
    const [albi, setAlbi] = useState([]);
    const [errore, setErrore] = useState(null);

    useEffect(() => {
        albiAPI.elenco()
            .then((r) => setAlbi(r.data?.data?.albi || []))
            .catch(() => setErrore('Non riesco a leggere l\'elenco degli albi'));
    }, []);

    const righe = valore.length ? valore : [];

    const cambia = (i, campo, v) => {
        const nuove = righe.map((r, k) => {
            if (k !== i) return campo === 'principale' && v ? { ...r, principale: false } : r;
            const agg = { ...r, [campo]: v };
            /* Cambiando albo la sede non vale piu': e' di un altro elenco. */
            if (campo === 'albo_codice') agg.sede_id = '';
            return agg;
        });
        onChange(nuove);
    };
    const aggiungi = () => onChange([...righe, { ...VUOTA, principale: righe.length === 0 }]);
    const togli = (i) => {
        const nuove = righe.filter((_, k) => k !== i);
        if (nuove.length && !nuove.some((r) => r.principale)) nuove[0] = { ...nuove[0], principale: true };
        onChange(nuove);
    };

    const sediDi = (codice) => (albi.find((a) => a.codice === codice)?.sedi || []).filter((s) => s.attiva !== false);
    const ambitoDi = (codice) => albi.find((a) => a.codice === codice)?.ambito;
    const etichettaSede = (codice) => ({ provincia: 'Provincia', regione: 'Regione', sede: 'Sede' }[ambitoDi(codice)] || 'Sede');

    return (
        <div className="ia-riquadro">
            {errore && <p className="rm-messaggio rm-messaggio-errore">{errore}</p>}
            {righe.length === 0 && (
                <p className="ia-vuoto">Nessuna iscrizione. Senza albo, sede e numero la riga
                    «Iscritto all'albo…» non si stampa sui referti.</p>
            )}
            {righe.map((r, i) => (
                <div key={i} className={`ia-riga ${r.principale ? 'ia-principale' : ''}`}>
                    <label className="ia-campo">
                        <span>Albo</span>
                        <select value={r.albo_codice || ''} disabled={disabilitato}
                                onChange={(e) => cambia(i, 'albo_codice', e.target.value)}>
                            <option value="">Scegli l'albo…</option>
                            {albi.map((a) => <option key={a.codice} value={a.codice}>{a.nome}</option>)}
                        </select>
                    </label>
                    <label className="ia-campo">
                        <span>{etichettaSede(r.albo_codice)}</span>
                        <select value={r.sede_id || ''} disabled={disabilitato || !r.albo_codice}
                                onChange={(e) => cambia(i, 'sede_id', e.target.value)}>
                            <option value="">{r.albo_codice ? 'Scegli…' : 'Prima l\'albo'}</option>
                            {sediDi(r.albo_codice).map((s) => <option key={s.id} value={s.id}>{s.nome}</option>)}
                        </select>
                    </label>
                    <label className="ia-campo">
                        <span>Numero</span>
                        <input type="text" value={r.numero || ''} disabled={disabilitato} maxLength={50}
                               onChange={(e) => cambia(i, 'numero', e.target.value)} />
                    </label>
                    <label className="ia-campo">
                        <span>Sezione <small>(se c'è)</small></span>
                        <input type="text" value={r.sezione || ''} disabled={disabilitato} maxLength={80}
                               placeholder="Es. Elenco speciale"
                               onChange={(e) => cambia(i, 'sezione', e.target.value)} />
                    </label>
                    <label className="ia-campo">
                        <span>Iscritto dal</span>
                        <input type="date" value={r.data_iscrizione ? String(r.data_iscrizione).slice(0, 10) : ''}
                               disabled={disabilitato}
                               onChange={(e) => cambia(i, 'data_iscrizione', e.target.value)} />
                    </label>
                    <label className="ia-campo ia-radio" title="Quella che si stampa per difetto">
                        <input type="radio" name="iscrizione_principale" checked={!!r.principale}
                               disabled={disabilitato} onChange={() => cambia(i, 'principale', true)} />
                        <span>principale</span>
                    </label>
                    <button type="button" className="ia-togli" onClick={() => togli(i)} disabled={disabilitato}
                            title="Togli questa iscrizione">
                        <X size={14} strokeWidth={2} aria-hidden="true" />
                    </button>
                </div>
            ))}
            <button type="button" className="ia-aggiungi" onClick={aggiungi} disabled={disabilitato}>
                <Plus size={14} strokeWidth={2} aria-hidden="true" /> Aggiungi un'iscrizione
            </button>
            <small className="form-nota">
                Sui referti si stampa «Iscritto all'<i>albo</i> <i>sede</i> n. <i>numero</i>»,
                dall'iscrizione principale. Se manca uno dei tre, concludere un referto
                avvisa prima. Chi ha due titoli (per esempio fisioterapista e osteopata)
                aggiunge due righe.
            </small>
        </div>
    );
};

export default IscrizioniAlbo;
